<template>
  <div class="widget-item" :id="widget.object.wid" :style="style">
    <DateView :app="widget.object" />
  </div>
</template>

<script>
  import DateView from '@/components/apps/date/DateView.vue';
  import { simpleTypeMixin } from '@/helpers';
  import templateWidget from '../../mixins/templateWidget';

  export default {
    name: 'DateWidget',

    components: { DateView },

    mixins: [templateWidget, simpleTypeMixin],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return {
          ...this.defaultStyling(this.widget),
          overflow: 'hidden',
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }
</style>
